import React from 'react';
import { useNode } from '@craftjs/core';
import ContentEditable from 'react-contenteditable';
import { Box } from '@mui/material';

export const TextSettings = () => {
  const {
    actions: { setProp },
    fontSize,
    textAlign,
    color,
    fontWeight,
  } = useNode((node) => ({
    fontSize: node.data.props.fontSize,
    textAlign: node.data.props.textAlign,
    color: node.data.props.color,
    fontWeight: node.data.props.fontWeight,
  }));

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ mb: 2 }}>
        <label>Размер шрифта</label>
        <input
          type="range"
          min="12"
          max="48"
          value={fontSize}
          onChange={(e) => setProp((props) => (props.fontSize = e.target.value))}
        />
        <span>{fontSize}px</span>
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Выравнивание</label>
        <select
          value={textAlign}
          onChange={(e) => setProp((props) => (props.textAlign = e.target.value))}
        >
          <option value="left">Слева</option>
          <option value="center">По центру</option>
          <option value="right">Справа</option>
          <option value="justify">По ширине</option>
        </select>
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Цвет</label>
        <input
          type="color"
          value={color}
          onChange={(e) => setProp((props) => (props.color = e.target.value))}
        />
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Жирность</label>
        <select
          value={fontWeight}
          onChange={(e) => setProp((props) => (props.fontWeight = e.target.value))}
        >
          <option value="normal">Обычный</option>
          <option value="bold">Жирный</option>
        </select>
      </Box>
    </Box>
  );
};

export const Text = ({ text, fontSize, textAlign, color, fontWeight }) => {
  const {
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    selected: state.events.selected,
  }));

  return (
    <Box
      ref={(ref) => connect(drag(ref))}
      sx={{
        p: 1,
        border: selected ? '2px solid #00ACC1' : '2px solid transparent',
        cursor: 'move',
        '&:hover': {
          border: '2px dashed #00ACC1',
        },
      }}
    >
      <ContentEditable
        html={text}
        onChange={(e) =>
          setProp((props) => (props.text = e.target.value), 500)
        }
        tagName="div"
        style={{
          fontSize: `${fontSize}px`,
          textAlign,
          color,
          fontWeight,
          outline: 'none',
        }}
      />
    </Box>
  );
};

Text.craft = {
  props: {
    text: 'Текст',
    fontSize: 16,
    textAlign: 'left',
    color: '#000000',
    fontWeight: 'normal',
  },
  related: {
    settings: TextSettings,
  },
};
